export const urlSecurity = 'https://www.mercadopago.com/v2/security.js'

export const cardFormFields = {
  id: 'form-checkout',
  cardNumber: {
    id: 'form-checkout__cardNumber',
    placeholder: 'Card number'
  },
  expirationDate: {
    id: 'form-checkout__expirationDate',
    placeholder: 'MM/YY'
  },
  securityCode: {
    id: 'form-checkout__securityCode',
    placeholder: 'Security code'
  },
  cardholderName: {
    id: 'form-checkout__cardholderName',
    placeholder: 'Cardholder name'
  },
  issuer: {
    id: 'form-checkout__issuer',
    placeholder: 'Issuer'
  },
  installments: {
    id: 'form-checkout__installments',
    placeholder: 'Installments'
  },
  identificationType: {
    id: 'form-checkout__identificationType',
    placeholder: 'Identification type'
  },
  identificationNumber: {
    id: 'form-checkout__identificationNumber',
    placeholder: 'Identification number'
  },
  cardholderEmail: {
    id: 'form-checkout__cardholderEmail',
    placeholder: 'Email'
  }
}
